<template>
  <div>
    <v-chip v-if="streak" class="pl-1" color="white" @click="showDlg=!showDlg">
      <v-icon class="ml-0" :color="eingabeToday ? 'orange' : 'blue lighten-3'">mdi-fire</v-icon>
      <span class="font-weight-bold dunkelblau--text" style="margin-top:2px">{{streak.Count}}</span>
      <div>
        <v-icon class="ml-1 mr-1" small :color="'blue'">mdi-diamond-stone</v-icon>
        <span class="font-weight-bold dunkelblau--text" style="margin-top:2px">{{deNaN((gamification||{}).diamonds)}}</span>
      </div>
    </v-chip>
    <v-chip v-else>
      <v-icon class="ml-0" color="lightgrey">mdi-fire</v-icon>
    </v-chip>
    <!--===========================-->
    <!--streak explanation dialog-->
    <!--===========================-->
    <v-dialog v-model="showDlg" max-width="400px">
      <v-card>
        <v-card-title class="headline">
          Eingabesträhne
        </v-card-title>
        <v-card-text class="pa-3">
          <div class="d-flex mb-3 pr-3">
            <v-icon size="60" :color="eingabeToday ? 'orange' : 'blue lighten-3'" class="ml-auto">mdi-fire</v-icon>
            <span class="display-3 mr-auto">{{streak.Count}}</span>
          </div>
          <p class="px-3">Gib jeden Tag deine Daten ein um die Strähne zu verlängern.</p>
          <div>
            <div class="pl-3 font-weight-bold my-2">7-Tage Rückblick:</div>
            <div class="d-flex  justify-space-between mx-3">
              <div v-for="day in days" class="">
                <v-icon :color="day.hasRecords ? 'orange' : 'blue lighten-3'">mdi-fire</v-icon>
                <p class="text-center"><b>{{day.wochentag}}</b></p>
              </div>
            </div>
          </div>
          <div class="px-3">
            Je länger deine Strähne ist, desto mehr Diamanten wirst du jede Woche sammeln.
            <br/><br/>
            <b>7 Flammen = 1 Diamant</b> (derzeit {{diasProWoche}} Diamanten pro Woche)
            <br/><br/>
            Achtung: wenn du drei Tage hintereinander nichts eingibst, verlierst du deine Strähne.
            Bevor das passiert, bekommst du aber ein Erinnerungsmail.
            <br/><br/>
            Wenn du einmal länger verhindert bist, kannst du unter
            Eingabe die ganze Woche pausieren. Dann bleibt deine Strähne bis nach der Pause erhalten.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn class="mx-auto mb-2 gelb" @click="showDlg=false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Kinds from "@/components/Kinds";
import {DateTime, Duration} from "luxon";

export default {
  name: "EingabeStreak",
  data() {
    return {
      streak:undefined,
      days: [],
      showDlg: false,
      eingabeToday:false,
      gamification: undefined,
    };
  },
  mounted() {
    this.load();
    this.$events.$on("update_streak", ()=>setTimeout(()=> this.load(), 1000));
  },
  methods: {
    async load() {
      console.log("loading streak ...");
      this.days=[];
      var date = new Date(Date.now());
      var id = date.toISOString().substr(0, 7); // YYYY-MM
      var streak=this.streak=(await this.$backend.get_current_streak("@InputStreak")) || {Count:0, SevenDayReview:[false, false, false, false, false, false, false]};
      console.log({streak})
      var today=DateTime.fromJSDate(date).setLocale("de");
      var lastWeek=today.minus(Duration.fromObject({days:6}));
      var hasRecords=false;
      for(var i = 0; i<7; i++){
        var day = lastWeek.plus(Duration.fromObject({days:i}));
        var wochentag=day.weekdayLong.substr(0,1);
        var iso = day.toISODate();
        hasRecords=this.streak.SevenDayReview[i]===true;
        this.days.push({wochentag, iso, hasRecords});
      }
      this.gamification=await this.$backend.get_settings("@gamification")
      this.eingabeToday=hasRecords;
    },
    deNaN(x) {
      if (isNaN(x) || x===undefined || x===null)
        return 0;
      return x;
    },
  },
  computed: {
    diasProWoche() {
      return this.deNaN(Math.floor(((this.streak||{}).Count || 0) / 7));
    },
    mobile() {
      return this.$app.mobile;
    }
  }
}
</script>

<style scoped>

</style>